export const environment = {
    url: 'https://app-api-builtup-prd-eastus2.azurewebsites.net/api',
    production: true,
    sentry: {
      enabled: true,
      dsn: 'https://3c6ffdd9c6dd632b5ec4e920eb0df934@o4511627544231936.ingest.us.sentry.io/4511829502787584',
      environment: 'production',
      release: '',
    },
  };